<div *ngIf="invited.length > 0">
  <div class="div-header">
    <span class="invited-header" i18n="@@invitedAcceptanceComment">
      <span class="glyphicon glyphicon-info-sign"></span>
      Once a user accepts an invitation, they will appear under the <span class="styled-text">Users</span> tab and will be removed from the invited list.
    </span>
    <div class="column form-group input-right">
      <div class="spinner-margin column spinner sm spinner-input-search" *ngIf="showSpinner"></div>
      <label class="sr-only" for="email-input-invited" i18n="Email Search|Searching for invited via emails@@invitedLabelSearchEmail">Search by email</label>
      <div class="input-group input-search">
              <span class="input-group-addon glyphicon-background-transparent input-border-none icon-margin-bottom">
                <span class="glyphicon glyphicon-search"></span>
              </span>
        <input class="form-control input-border-none" id="email-input-invited" i18n-placeholder="Email Address Placeholder|Placeholder text for the input@@invitedPlaceholderEmail" placeholder="Search by email address" name="emailInput" type="text" [(ngModel)]="emailInvitedSearch" (input)="searchInvitedEmail()" (keyup.backspace)="handleInvitedBackspace($event)" (keyup.enter)="searchInvitedOnEnter()"/>
        <i class="close-icon" *ngIf="emailInvitedSearch.length > 0" (click)="resetInvited()"></i>
      </div>
      <div id="downloadButton">
        <button id="downloadUsersButton"
                class="btn btn-default download-button custom-tooltip"
                placement="bottom"
                type="submit"
                [disabled]="showCsvSpinner"
                (click)="downloadCSVFile()">
          <ng-container *ngIf="!showCsvSpinner">
            <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span>
            <span i18n="@@adminUserExportButton"> Download</span>
          </ng-container>
          <ng-container *ngIf="showCsvSpinner">
            <span class="spinner-border" role="status" aria-hidden="true"></span>
            <span i18n="@@adminUserDownloadingButtonText"> Downloading...</span>
          </ng-container>
        </button>
      </div>
    </div>
  </div>
  <table class="table users invites" id="invited">
    <thead>
    <tr>
      <th class="specific-width-invited-email" i18n="Email|Invited Email address@@invitedTableHeaderEmail">Email</th>
      <th class="auto-width" i18n="Date|Invited date@@invitedTableHeaderName">Invite Date</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of invited">
      <td>{{ data.email ? data.email : '' }}</td>
      <td>{{ data.created | date:'MMMM d, yyyy' }}</td>
    </tr>
    </tbody>
  </table>
  <div class="pull-right text-muted" id="InvitedPagination">
    <nav class="pull-right" aria-label="Page navigation" *ngIf="totalCountOfInvited > pageSize">
      <ul class="pagination">
        <li [ngClass]="{'disabled':start < 1}">
          <a href="#" aria-label="Previous" (click)="previousPageInvited()"><span aria-hidden="true"><</span></a>
        </li>
        <li [ngClass]="{'disabled':end >= totalCountOfInvited}">
          <a href="#" aria-label="Next" (click)="nextPageInvited()"><span aria-hidden="true">></span></a>
        </li>
      </ul>
    </nav>
    <div class="pagination-container">
      <div class="pagination-dropdown">
        <select class="custom-dropdown" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
          <option *ngFor="let option of pageSizeOptions" [ngValue]="option" i18n="@@usersTablePerPage">{{ option }} per page</option>
        </select>
      </div>
      <div class="pull-right" id="pagination-info" i18n="@@invitesTablePage">
        <strong>{{ start + 1 }}</strong> - <strong>{{ end }}</strong> of <strong>{{ totalCountOfInvited }}</strong> invites
      </div>
    </div>
  </div>
</div>
<div *ngIf="invited.length === 0">
  <div class="no-data-text">No outstanding invites</div>
  <div class="no-data-button">
    <button class="btn btn-primary"
            i18n="Inviting Users link|A link to the Invite Users section@@usersSearchButton"
            routerLink="/users/invite">
      <span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> Invite Users
    </button>
  </div>
</div>
